interface Props {
  uri: string
  port: number
  IPAddress: string
}

interface PrintPdfByFile {
  base64String: string;
  port: number
  IPAddress: string
  offsetX: number
  offsetY: number
  dpi: number
}

interface PrintWithSetup extends PrintPdfByFile {
  width: number
  height: number
}

export interface PrinterPlugin {
  print(call: Props): Promise<{}>,
  printPdf(call: PrintPdfByFile): Promise<{}>,
  printPdfWithSetup(call: PrintWithSetup): Promise<{}>,
}
